// import { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function Insidecrypto() {
    // useEffect(() => {
    //     // Dynamically add JS
    //     const script = document.createElement("script");
    //     script.src = "/js/index.js";
    //     script.defer = true;
    //     document.body.appendChild(script);

    //     // Dynamically add CSS
    //     const link = document.createElement("link");
    //     link.rel = "stylesheet";
    //     link.href = "/css/extend.css";
    //     document.head.appendChild(link);

    //     // Cleanup on unmount
    //     return () => {
    //         document.body.removeChild(script);
    //         document.head.removeChild(link);
    //     };
    // }, []);
    return (
        <>
            <Header />
            <div class="insidecrypto-div">

                <div class="insidecrypto-div-sub">
                    <iframe src="https://insidecrypto.advagroup.com.au" title="insidecrypto" height="800" class="relative w-full overflow-hidden" allow="fullscreen; clipboard-write; autoplay" ></iframe>
                </div>
            </div>

            <Footer />
        </>
    )
}